export enum SearchVisibility {
  Public = 0,
  Private = 1
}
